import { render } from "./Navigation.vue?vue&type=template&id=5c23d0d2"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
script.render = render

export default script